export default class InvokeFields {

    public static getAppleReport = "getAppleReport";
    public static getGooglePlayReport = "getGooglePlayReport";
    public static getFlurryUsage = "getFlurryUsage";
    public static getFlurryEventParams = "getFlurryEventParams";
    public static getGoogleAnalyticsUserSessions = "getGoogleAnalyticsUserSessions";
    public static getGoogleAnalyticsTrafficSources = "getGoogleAnalyticsTrafficSources";
    public static getGoogleAnalyticsPageViews = "getGoogleAnalyticsPageViews";
    public static getLinkedInAccessToken = "getLinkedInAccessToken";
    public static sendPushNotifications = "sendPushNotifications";
    public static getTwitterDataset = "getTwitterDataset";
}